<mat-card class="cardWithShadow theme-card">
  <mat-card-header>
    <mat-card-title class="m-b-0">Divider</mat-card-title>
  </mat-card-header>
  <mat-card-content class="b-t-1">
    <div class="row">
      <div class="col-lg-6">
        <mat-card class="b-1 shadow-none">
          <mat-card-header>
            <mat-card-title>Basic</mat-card-title>
          </mat-card-header>
          <mat-card-content class="b-t-1">
            <mat-list>
              <mat-list-item>Item 1</mat-list-item>
              <mat-divider></mat-divider>
              <mat-list-item>Item 2</mat-list-item>
              <mat-divider></mat-divider>
              <mat-list-item>Item 3</mat-list-item>
            </mat-list>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-lg-6">
        <mat-card class="b-1 shadow-none">
          <mat-card-header>
            <mat-card-title>Inset</mat-card-title>
          </mat-card-header>
          <mat-card-content class="b-t-1">
            <mat-list>
              <mat-list-item>Home</mat-list-item>
              <mat-divider [inset]="true"></mat-divider>
              <mat-list-item>UI</mat-list-item>
              <mat-divider [inset]="true"></mat-divider>
              <mat-list-item>Forms</mat-list-item>
            </mat-list>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="col-lg-6">
        <mat-card class="b-1 shadow-none">
          <mat-card-header>
            <mat-card-title>Vertical</mat-card-title>
          </mat-card-header>
          <mat-card-content class="b-t-1">
            <mat-list class="d-flex">
              <mat-list-item>Home</mat-list-item>
              <mat-divider [vertical]="true"></mat-divider>
              <mat-list-item>UI</mat-list-item>
              <mat-divider [vertical]="true"></mat-divider>
              <mat-list-item>Forms</mat-list-item>
            </mat-list>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </mat-card-content>
</mat-card>
